import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EraserSvgComponent } from './eraser-svg.component';

@NgModule({
  declarations: [
    EraserSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    EraserSvgComponent
  ]
})
export class EraserSvgModule { }
